import React from 'react';
import ReactTooltip from 'react-tooltip';
import Reflux from 'reflux';

import AppStore from '../../AppStore';

import AppActions from '../../AppActions';
import ModalActions from '../../actions/ModalActions';
import RcIf from 'rc-if';
export default class TopicActions extends Reflux.Component {
    constructor (props) {
        super(props);
        this.store = AppStore;
    }

    like = (point) => {
        if (this.state.userData && this.state.userData.token) {
            if (point === '+1') {
                if (this.state.topicLikedByUser) {
                    this.setState({
                        topicLikes: this.state.topicLikes - 1,
                        topicLikedByUser: false
                    });
                } else {
                    this.setState({
                        topicLikes: this.state.topicLikes + 1,
                        topicLikedByUser: true
                    });

                    if (this.state.topicDislikedByUser) {
                        this.setState({
                            topicDislikedByUser: false,
                            topicDislikes: this.state.topicDislikes - 1
                        });
                    }
                }
            } else {
                if (this.state.topicDislikedByUser) {
                    this.setState({
                        topicDislikes: this.state.topicDislikes - 1,
                        topicDislikedByUser: false
                    });
                } else {
                    this.setState({
                        topicDislikes: this.state.topicDislikes + 1,
                        topicDislikedByUser: true,
                        topicLikedByUser: false
                    });

                    if (this.state.topicLikedByUser) {
                        this.setState({
                            topicLikedByUser: false,
                            topicLikes: this.state.topicLikes - 1
                        });
                    }
                }
            }
            const like = {
                userTopic: this.state.currentTopic._id,
                point: point
            };
            AppActions.likeTopic(like);
        } else {
            ModalActions.changeModalLoginStatus(true);
        }
    }

    render () {
        return (
          <RcIf if={!this.state.globalTopic} >
            <ul className='btnActionTop'>
              <li data-tip='Nah.' data-for='dislikeTop'>
                <a className='waves-effect waves-light dislike-btn ' onClick={() => this.like('-1')} >
                  <span className={'lessBtn ' + (this.state.topicDislikedByUser
                  ? 'lessBtnClicked'
                  : '')} />
                  <span className='shareTop'>{this.state.topicDislikes}</span>
                </a>
                <ReactTooltip place='top' type='dark' effect='solid' id='dislikeTop' />
              </li>
              <li data-tip='Yaaasss!' data-for='likeTop'>
                <a className='waves-effect waves-light like-btn ' onClick={() => this.like('+1')}>
                  <span className={'plusBtn ' + (this.state.topicLikedByUser
                  ? 'plusBtnClicked'
                  : '')} />
                  <span className='plusTop'>{this.state.topicLikes}</span>
                </a>
                <ReactTooltip place='top' type='dark' effect='solid' id='likeTop' />
              </li>
              <li>
                <a className='shareBtn waves-effect waves-light' onClick={(e) => AppActions.showSocial(e)}>
                  <span className={'thumb-action '}>
                    <i className='fa fa-share' aria-hidden='true' />
                  </span>
                  <span className='shareTop white-text'> - </span>
                </a>
              </li>
            </ul>
          </RcIf>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/topic/TopicActions.js